module.exports = __webpack_public_path__ + "static/media/JD-Advising_Logo.7ed45b77.svg";